/**
 * Default Google Maps libraries to load
 */
export const DEFAULT_LIBRARIES = ["geometry", "marker"];

/**
 * Default region for Google Maps
 */
export const DEFAULT_REGION = "CA";
